import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import storage from "./utils/storage";
import { getParams } from "./utils/authUtils";
import ProfileService from "./services/ProfileService";
import Swal from "sweetalert2";
import ScrollToTop from "./components/ScrollToTop";

import Loader from "./components/Loader";
import Unauthorized from "./pages/Unauthorized";
import Dashboard from "./pages/Home/Dashboard";
import Products from "./pages/Home/Products";
import ProductDetails from "./pages/Home/ProductDetails";
import MyLeads from "./pages/Home/MyLeads";
import LeadService from "./services/LeadService";

function App() {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(null);
  const [isUser, setIsUser] = useState(null);

  // First effect: check and set token + source
  useEffect(() => {
    const initAuth = () => {
      const { token, logo_url, brand_name, source } = getParams();

      if (token && source) {
        storage.setItem("access_token", token);
        storage.setItem("logo_url", logo_url || "");
        storage.setItem("brand_name", brand_name || "");
        storage.setItem("source", source);
        setAuthorized(true);
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } else {
        const storedToken = storage.getItem("access_token");
        const storedSource = storage.getItem("source");
        setAuthorized(!!(storedToken && storedSource));
      }
    };

    initAuth();
  }, []);

  // Second effect: fetch user status only after auth is confirmed
  useEffect(() => {
    const fetchUserStatus = async () => {
      try {
        const storedSource = storage.getItem("source");

        const result = await LeadService.verifyToken();
        if (!result.success) {
          Swal.fire(
            "Oops!",
            result.message || "Failed to fetch user status",
            "error"
          );
          setIsUser(false);
        } else {
          setIsUser(result.data?.status === "SUCCESS");
        }
      } catch (error) {
        Swal.fire(
          "Oops!",
          error?.response?.data?.message || error.message || "Request Failed",
          "error"
        );
        setIsUser(false);
      } finally {
        setLoading(false);
      }
    };

    if (authorized === true) {
      fetchUserStatus();
    } else if (authorized === false) {
      setLoading(false);
    }
  }, [authorized]);

  if (loading || authorized === null) return <Loader />;

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {!authorized && <Route path="*" element={<Unauthorized />} />}

        {authorized && (
          <>
            <Route path="/" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product-details" element={<ProductDetails />} />
            <Route path="/my-leads" element={<MyLeads />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
